// components/courier-dashboard/MetricCard.tsx
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Info } from "lucide-react";
import * as Tooltip from "@radix-ui/react-tooltip";

export type MetricCardProps = {
  title: string;
  value: string | number;
  info?: string;
  description?: string;
};

export function MetricCard({ title, value, info, description }: MetricCardProps) {
  return (
    <Card className="bg-white">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 bg-white">
        <CardTitle className="text-sm font-medium bg-white flex items-center gap-2">
          {title}
        </CardTitle>

        {info && (
          <Tooltip.Provider delayDuration={150}>
            <Tooltip.Root>
              <Tooltip.Trigger asChild>
                <button
                  aria-label={`Info ${title}`}
                  className="text-gray-500 hover:text-gray-700"
                  title={info} // fallback nativo
                >
                  <Info className="h-4 w-4" />
                </button>
              </Tooltip.Trigger>
              <Tooltip.Portal>
                <Tooltip.Content
                  side="top"
                  sideOffset={6}
                  className="z-50 max-w-[280px] rounded-md bg-black/80 text-white px-3 py-2 text-xs leading-snug"
                >
                  {info}
                  <Tooltip.Arrow className="fill-black/80" />
                </Tooltip.Content>
              </Tooltip.Portal>
            </Tooltip.Root>
          </Tooltip.Provider>
        )}
      </CardHeader>

      <CardContent className="bg-white">
        <div className="text-2xl font-bold">{value}</div>
        {description && <p className="text-xs text-muted-foreground mt-1">{description}</p>}
      </CardContent>
    </Card>
  );
}